import styled from 'styled-components';
import { Form } from '@unform/web';

export const Formulario = styled(Form)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;

  width: 95%;
  margin: 1rem;

  button {
    align-self: flex-end;
  }
`;

export const CampoConteiner = styled.div`
  display: flex;
  gap: 1rem;

  width: 100%;
`;

export const TabelaVinculos = styled.table`
  width: 95%;
  margin-bottom: 1rem;

  border-collapse: collapse;
  border-spacing: 0;
`;

export const THeader = styled.th`
  padding: 0.5rem;

  text-align: left;
`;

export const Td = styled.td`
  padding: 0.5rem;

  text-align: left;
`;

export const Tr = styled.tr`
  &:nth-child(even) {
    background-color: #f2f2f2;
  }
`;

export const AcoesConteiner = styled.div`
  display: flex;
  justify-content: flex-end;

  width: 95%;
  margin-right: 10px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-evenly;
`;
